import React from "react";
import { CubeIcon } from "@heroicons/react/24/outline";
import { useModalsContext } from "../context/ShipmentsTableModalsContext";
import { useShipmentSelectionContext } from "../context/ShipmentSelectionContext";
import { OrdersPageModalNames } from "../utils/ordersPageModalNames";
import { ShipmentRow } from "../types";
import CourieButton from "@src/common/components/Button/Button";

interface PackageStatusBadgesProps {
  displayPackageStatuses: string[] | null | undefined;
  row: ShipmentRow;
}

export function PackageStatusBadges({
  displayPackageStatuses,
  row,
}: PackageStatusBadgesProps) {
  const { setModalOpen } = useModalsContext();
  const { setShipmentSelectedForAction, setSelectedRow } = useShipmentSelectionContext();

  if (!displayPackageStatuses || displayPackageStatuses.length === 0) {
    return null;
  }

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (row?.shipment) {
      setShipmentSelectedForAction(row.shipment);
      setSelectedRow(row);
      setModalOpen(true, OrdersPageModalNames.PACKAGE_EVENTS);
    }
  };

  const statusText = displayPackageStatuses.join(", ");

  return (
    <CourieButton
      color="link"
      size="xs"
      className="mt-1"
      onClick={handleClick}
    >
      <CubeIcon className="h-4 w-4 mr-1" />
      <span>{statusText}</span>
    </CourieButton>
  );
}

